export default __webpack_public_path__ + "static/media/77_photo.b8ccb948.jpg";